module.exports = __webpack_public_path__ + "img/battle-crackers-thumbnail.38f8fa76.jpg";